document.addEventListener('DOMContentLoaded', function () {
  const PR = window.PRPurchase;
  const productForm = document.querySelector('.product-single__form');
  if (!productForm || !PR) return;
  const root = productForm.closest('[data-pr-pdp]');
  if (!root || root.dataset.prFlavor !== 'yummies') return;

  const FREE_SHIPPING_THRESHOLD_CENTS = PR.FREE_SHIPPING_THRESHOLD_CENTS;
  const productData = PR.readProduct(productForm);
  const plans = PR.readPlans();
  const productContainer = root.querySelector('.custom-subscription-widget-container');
  if (!productContainer || !productData) return;

  const subscriptionIdInput = productForm.querySelector('input[name="selling_plan"]');
  const variantIdInput = productForm.querySelector('[name="id"]');
  const btnTextElement = productForm.querySelector('.btn--add-to-cart .btn__text');
  const shippingPriceElement = productContainer.querySelector('#buy-once-option .shipping-price');
  const packButtons = productContainer.querySelectorAll('.pack-button');

  const offerRadios = productForm.querySelectorAll('[data-pr-offer-radio], input[name="option1"]');

  // Subscriptions sell 60 only -- 60 every month (2 jars), 180 every 3 months
  // (6 jars). The 30/60 picker that used to sit above the cards is gone: 30 is
  // now the Try link under Add to Cart, so nothing varies the count at runtime.
  //
  // Every subscription figure derives from this one number: the 3-month card is
  // SUBSCRIPTION_COUNT * 3, and the jar labels divide by JAR_SIZE. Both 60 and
  // 180 exist as variants; the * 6 card is not offered for Yummies (PLAN_IDS
  // carries monthly and threeMonth only).
  //
  // This was 90 for a week (5-12 Sep 2026, 3 and 9 jars) and went back to 60
  // by decision, not by accident. The 90 / 270 variants and plans still exist.
  const SUBSCRIPTION_COUNT = '60';

  let selectedOffer = '';
  let selectedPackCount = '60';

  const getVariant = function (offer, count) {
    return productData.variants.find(function (v) {
      return v.option1 === offer && String(v.option2) === String(count);
    });
  };

  const unitPrice = function () {
    const v30 = getVariant(selectedOffer, '30');
    return v30 && v30.price > 0 ? v30.price / 30 : 3500 / 30;
  };

  const formulaBase = function (count) {
    return (parseInt(count, 10) || 0) * unitPrice();
  };

  // Ported from the Brooklyn theme's yummies-plan-map. Rose Yummies has five
  // generic percentage "Subscribe & Save" groups that sort ahead of its
  // product-specific fixed-price plans, so selecting by kind alone prices from
  // the wrong group.
  //
  // Keyed by offer as well as cadence: the plans are fixed-price, and Sugar free
  // and Low sugar no longer cost the same, so one plan cannot serve both.
  //
  // These are the 60/180 plans, matching the 2-jar month and 6-jar quarter.
  // Since 12 Sep 2026 they bill on WEEK x 4 and WEEK x 12 (they had billed on
  // calendar months), which is why pr-rtx-yummies.liquid overrides the cadence
  // copy to "every 4 weeks" / "every 12 weeks":
  //   Sugar-Free 60  5757927643  $47 / 4 weeks   (Rose Yummies Sugar Free 60 Units)
  //   Sugar-Free 180 7253328091  $117 / 12 weeks (Sugar Free Yummies 180)
  //   Low Sugar 60   7034863835  $42 / 4 weeks   (Low Sugar Yummies 60)
  //   Low Sugar 180  7034601691  $105 / 12 weeks (Low Sugar Three month delivery)
  // Prices as re-set that day; they had been $62 / $165 and $56 / $147. The
  // stated badges in pr-rtx-yummies.liquid (40 / 50) follow these.
  //
  // The 90/270 plans sold for a week in Sep 2026 (7289929947, 7289962715,
  // 7290028251, 7289995483) still exist in Shopify for customers who
  // subscribed then, but must not be sold: they bill 3 and 9 jars on WEEK x 4
  // and WEEK x 12.
  //
  // The plan ID has to be exact rather than matched by kind: the Sugar-Free 180
  // variant also carries the "Three month delivery for Yummies 90 count" plan
  // (7033946331, $87), which would price a 6-jar quarter as a 3-jar one.
  //
  // The 30-count plans (7034831067, 7033946331) are likewise unreachable: 30 is
  // the Try link under Add to Cart, not a subscription.
  const PLAN_IDS = {
    'sugar free': { monthly: 5757927643, threeMonth: 7253328091 },
    'low sugar': { monthly: 7034863835, threeMonth: 7034601691 },
  };

  // The option value is "Sugar-Free" in Shopify but the key here is "sugar
  // free", so lowercasing alone never matched and every Sugar-Free lookup fell
  // through to a generic allocation. Fold anything non-alphanumeric to a single
  // space so hyphenated, re-cased or re-spaced merchandising copy all land on
  // the same key.
  const normalizeOffer = function (offer) {
    return String(offer || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  };

  const planIdFor = function (offer, kind) {
    const forOffer = PLAN_IDS[normalizeOffer(offer)];
    return (forOffer && forOffer[kind]) || null;
  };

  const getTargetData = function (isSubscription, offer, count, kind, planId) {
    const variant = getVariant(offer, count);
    if (!variant) return { variant: null, price: 0, sellingPlan: '' };
    const record = PR.variantRecord(plans, variant.id);
    if (isSubscription) {
      const alloc = PR.allocation(record, kind, planId);
      if (alloc && alloc.price > 0) {
        return { variant: variant, price: alloc.price, sellingPlan: alloc.plan_id };
      }
    }
    return { variant: variant, price: variant.price, sellingPlan: '' };
  };

  // The pack grid is the only thing that sets the Buy Once count now, and it is
  // always rendered, so there is no picker state left to reconcile it against.
  const effectiveBuyOnce = function () {
    return selectedPackCount;
  };

  // Yummies ship in jars of 30, so every card counts jars and restates the jar
  // size: "2 Jars x 30 Yummies". The "x 30 Yummies" was dropped for
  // a week in Sep 2026 on the grounds that the jar was the unit everywhere and
  // needed no restating; it came back by request on 12 Sep 2026, so the
  // shopper can see how many gummies a shipment holds without doing the sum.
  // The pack buttons stay "2 Jars": three of them share one row and the long
  // form does not fit. unit_in_js is set on the widget so the phrase below is
  // the whole label, with no " yummies" appended after.
  const JAR_SIZE = 30;

  const jarsLabel = function (count) {
    const jars = Math.round(count / JAR_SIZE);
    return jars + (jars === 1 ? ' Jar' : ' Jars') + ' x ' + JAR_SIZE + ' Yummies';
  };

  const updateLabels = function () {
    const monthly = parseInt(SUBSCRIPTION_COUNT, 10);
    const monthlyEl = productContainer.querySelector('.js-monthly-qty');
    if (monthlyEl) monthlyEl.textContent = jarsLabel(monthly);
    const threeEl = productContainer.querySelector('.js-three-month-qty');
    if (threeEl) threeEl.textContent = jarsLabel(monthly * 3);
    const sixEl = productContainer.querySelector('.js-six-month-qty');
    if (sixEl) sixEl.textContent = jarsLabel(monthly * 6);
    const onceEl = productContainer.querySelector('.js-buy-once-count');
    if (onceEl) onceEl.textContent = jarsLabel(effectiveBuyOnce());
  };

  // The collapsed "Buy Once for ..." link renders server-side from
  // current_variant, so it never followed the count picker -- it stayed at the
  // default variant's price no matter what was selected.
  const updateBuyOnceTrigger = function () {
    const priceEl = productContainer.querySelector('.js-buy-once-price');
    const shipEl = productContainer.querySelector('.js-buy-once-shipping');
    if (!priceEl && !shipEl && !shippingPriceElement) return;
    const once = getTargetData(false, selectedOffer, effectiveBuyOnce(), 'onetime');
    if (!once.variant) return;
    if (priceEl) priceEl.textContent = PR.formatMoney(once.price);
    const free = once.price >= FREE_SHIPPING_THRESHOLD_CENTS;
    // The collapsed link supplies its own "+" in the markup; the card's line
    // stands alone under the price, so it carries the "+" itself.
    if (shipEl) shipEl.textContent = free ? 'Free Shipping' : PR.DEFAULT_SHIPPING_TEXT;
    // Priced from the one-time allocation so the card reads correctly even
    // while a subscription is the selected option.
    if (shippingPriceElement) {
      shippingPriceElement.textContent = free ? 'Free Shipping' : '+ ' + PR.DEFAULT_SHIPPING_TEXT;
    }
  };

  // The "Try 1 Jar" link under Add to Cart sells the 30-count of whichever
  // offer is selected. It renders server-side from the default offer, so it has
  // to be re-pointed when the shopper switches -- Sugar free and Low sugar are
  // separate variants at separate prices.
  const updateTryLink = function () {
    const link = document.querySelector('.js-try-30');
    if (!link) return;
    const variant = getVariant(selectedOffer, '30');
    if (!variant) {
      link.hidden = true;
      return;
    }
    link.hidden = false;
    link.dataset.variantId = variant.id;
    if (link.dataset.cartUrl) link.href = link.dataset.cartUrl + '/' + variant.id + ':1';
    const priceEl = link.querySelector('.js-try-30-price');
    if (priceEl) priceEl.textContent = PR.formatMoney(variant.price);
  };

  // The 2-jar Buy Once is 10% off two single jars since the pdp_buybox
  // switch-over ($70 / $63), and both formulas land on it to the dollar, so
  // every pack's badge derives. (Before, the 2-jar was stated as 20% because no
  // whole-dollar price made the arithmetic land on it.)
  const STATED_PACK_SAVE = {};

  const updateBadges = function () {
    ['60', '120', '180'].forEach(function (count) {
      const badge = productContainer.querySelector('[data-pack-save-badge="' + count + '"]');
      if (!badge) return;
      const variant = getVariant(selectedOffer, count);
      if (!variant) {
        badge.textContent = '';
        return;
      }
      const base = formulaBase(count);
      if (base <= variant.price) {
        badge.textContent = '';
        return;
      }
      const derived = ((base - variant.price) / base) * 100;
      const stated = STATED_PACK_SAVE[count];
      const pct = stated && Math.abs(derived - stated) <= 2 ? stated : Math.round(derived);
      badge.textContent = 'Save ' + pct + '%';
    });
  };

  const updateFormAndPrices = function () {
    const selectedRadio = productContainer.querySelector('input[name="purchase_option"]:checked');
    if (!selectedRadio || !selectedOffer) return;
    const kind = selectedRadio.dataset.planKind || 'onetime';
    const isSubscription = kind !== 'onetime';
    const mult = parseInt(selectedRadio.dataset.countMultiplier, 10) || 1;
    let count = isSubscription ? String(parseInt(SUBSCRIPTION_COUNT, 10) * mult) : effectiveBuyOnce();
    if (isSubscription && !getVariant(selectedOffer, count)) count = SUBSCRIPTION_COUNT;

    const data = getTargetData(isSubscription, selectedOffer, count, kind, planIdFor(selectedOffer, kind));
    if (!data.variant) return;

    if (variantIdInput) {
      variantIdInput.value = data.variant.id;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (subscriptionIdInput) subscriptionIdInput.value = data.sellingPlan || '';

    const nativeCount = productForm.querySelector('input[name="option2"][value="' + count + '"]');
    if (nativeCount) nativeCount.checked = true;

    const buyOnceLabel = productContainer.querySelector('#buy-once-option');
    if (buyOnceLabel) {
      const once = getTargetData(false, selectedOffer, effectiveBuyOnce(), 'onetime');
      if (once.variant) PR.fillPriceDetails(buyOnceLabel, once.price, formulaBase(effectiveBuyOnce()), 1, true);
    }

    productContainer.querySelectorAll('.purchase-option-label:not(.purchase-option-onetime)').forEach(function (label) {
      const radio = label.querySelector('input[name="purchase_option"]');
      if (!radio) return;
      const k = radio.dataset.planKind;
      const m = parseInt(radio.dataset.countMultiplier, 10) || 1;
      let c = String(parseInt(SUBSCRIPTION_COUNT, 10) * m);
      if (!getVariant(selectedOffer, c)) c = SUBSCRIPTION_COUNT;
      const vd = getTargetData(true, selectedOffer, c, k, planIdFor(selectedOffer, k));
      if (vd.variant) {
        PR.fillPriceDetails(label, vd.price, formulaBase(c), m, false);
        radio.dataset.sellingPlanId = vd.sellingPlan || '';
      }
    });

    updateLabels();
    updateBadges();
    updateBuyOnceTrigger();
    updateTryLink();

    if (btnTextElement) btnTextElement.textContent = PR.ctaText(productContainer, data.variant.available);
  };

  offerRadios.forEach(function (radio) {
    if (radio.checked) selectedOffer = radio.value;
    radio.addEventListener('change', function (e) {
      selectedOffer = e.target.value;
      updateFormAndPrices();
    });
  });

  packButtons.forEach(function (button) {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      packButtons.forEach(function (b) {
        b.classList.remove('is-selected-pack');
      });
      button.classList.add('is-selected-pack');
      selectedPackCount = button.dataset.packValue;
      const current = productContainer.querySelector('input[name="purchase_option"]:checked');
      if (current && current.value === 'onetime') updateFormAndPrices();
    });
  });

  PR.bindBuyOncePackReset(productContainer, function (pack) {
    selectedPackCount = pack;
    updateFormAndPrices();
  });

  productContainer.querySelectorAll('input[name="purchase_option"]').forEach(function (radio) {
    radio.addEventListener('change', updateFormAndPrices);
  });

  if (!selectedOffer) {
    const firstOffer = productForm.querySelector('[data-pr-offer-radio]:checked, input[name="option1"]:checked');
    if (firstOffer) selectedOffer = firstOffer.value;
  }

  PR.bindSelection(productContainer);
  PR.bindBanner(root);
  PR.bindOfferAccordions(root);
  PR.bindVideos(root);
  updateFormAndPrices();
});
